exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flip-list-move[data-v-de842474] {\n  transition: transform 0.5s;\n}\n.no-move[data-v-de842474] {\n  transition: transform 0s;\n}\n.ghost[data-v-de842474] {\n  visibility: hidden;\n}\n.list-group[data-v-de842474] {\n  min-height: 20px;\n}\n.list-group-item[data-v-de842474] {\n  cursor: move;\n}\n.list-group-item i[data-v-de842474] {\n  cursor: pointer;\n}", ""]);

// exports
